import AnkorLogo from '@/assets/AnkorLogo.svg'

import './VirtualCard.css'

export type VirtualCardFrontProps = {
  cardHolder: string
  cardLast4Digits: string
  isFlipped: boolean
}

export const VirtualCardFront = ({ cardHolder, cardLast4Digits, isFlipped }: VirtualCardFrontProps) => {
  return (
    <div
      className={`
        holo-shine holo-shine-front-hover absolute inset-0 [backface-visibility:hidden] rounded-2xl p-4 shadow-md border overflow-hidden transition-all duration-500 hover:scale-105 hover:shadow-lg bg-gradient-to-br from-gray-50 to-gray-200 dark:from-gray-800 dark:to-gray-900 border-gray-100 dark:border-gray-700
        ${isFlipped ? 'z-0' : 'z-10'}
      `}
    >
      <img
        src={AnkorLogo}
        alt="Ankor Logo"
        className="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 w-36 h-36 opacity-10 pointer-events-none select-none"
      />
      <div className="relative z-10 flex flex-col justify-between h-full">
        <div className="flex justify-between items-start">
          <span className="text-sm tracking-widest text-gray-700 dark:text-gray-200">VIRTUAL</span>
          <div className="flex flex-col items-end">
            <span className="text-lg font-bold leading-none text-gray-700 dark:text-gray-200">Ankor</span>
            <span className="text-xs font-medium text-gray-500 dark:text-gray-400">Debit</span>
          </div>
        </div>
        <div className="flex justify-between items-end">
          <div className="flex flex-col">
            <span className="text-sm text-gray-700 dark:text-gray-200">{cardHolder}</span>
            <span className="text-sm tracking-widest text-gray-900 dark:text-gray-50">•••• {cardLast4Digits}</span>
          </div>
          <div className="flex flex-col items-end">
            <span className="text-lg font-bold leading-none text-gray-700 dark:text-gray-200">VISA</span>
            <span className="text-xs text-gray-500 dark:text-gray-400">Business</span>
          </div>
        </div>
      </div>
    </div>
  )
}
